module.exports = __webpack_public_path__ + "img/2023-16.62fd691f.jpg";